import { AreaDataSet, AreaSearchParam } from "../types/WebData";
import API from "./api";
import * as MESSAGE from "../const/message";
import { HTTP_STATUS_CODE } from "../const/index";

/**
 * areaテーブルAPI
 * エリア詳細情報取得
 *
 * @param {number} AreaId
 * @return {*} 
 */
export const getSearchAreaId = async (AreaId: number) => {
  const result = await API.get(`/cms-api/area/id`, { params: { id: AreaId } })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });

  return result;
};

/**
 * areaテーブルAPI
 * エリア情報検索
 *
 * @param {AreaSearchParam} searchParam
 * @return {*} 
 */
export const postSearchArea = async (searchParam: AreaSearchParam) => {
  const result = await API.post(`/cms-api/area/search`, searchParam)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });

  return result;
};

/**
 * areaテーブルAPI 更新
 *
 * @param {AreaDataSet} postData
 */
export const updateArea = async (postData: AreaDataSet) => {
  if (postData.id === 0) {
    // insert
    const result = await API.post("/cms-api/area", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.TOROKU_SEIKO };
      })
      .catch((error) => {
        return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
      });
    return result;
  } else {
    // update
    const result = await API.put("/cms-api/area/id", postData)
      .then((res) => {
        return { isError: false, message: MESSAGE.KOSHIN_SEIKO };
      })
      .catch((error) => {
        const status = error.response.status;
        const message = status === HTTP_STATUS_CODE.CONFLICT_ERROR ? MESSAGE.CONFLICT_ERROR : MESSAGE.SYSTEM_ERROR;
        return { isError: true, message: message, data: [] };
      });
    return result;
  }
};

/**
 * areaテーブルAPI del_flg更新
 *
 * @param {number} id
 * @param {boolean} del_flg
 */
export const deleteArea = async (id: number, del_flg: boolean) => {
  const result = await API.put("/cms-api/area/delete", { id: id, del_flg: del_flg })
    .then((res) => {
      return { isError: false, message: "" };
    })
    .catch((error) => {
      return { isError: true, message: MESSAGE.SYSTEM_ERROR, data: [] };
    });
  return result;
};